import axios from '@axios';

export default {
	namespaced: true,
	state: {},
	getters: {},
	mutations: {},
	actions: {
		fetchRequestEconomicTemplate(ctx, { id }) {
			return new Promise((resolve, reject) => {
				axios
					.get(`/request-economic-templates/${id}/edit`)
					.then(response => resolve(response))
					.catch(error => reject(error));
			});
		},
	}
}